// extracted by mini-css-extract-plugin
export var locationCard = "_hp-0";